<div #contentWrapper class="content-wrapper" [style.transform]="fitToPageScale">
	<ng-content></ng-content>
</div>
